// require('./vendor'); // vem do webkit

import LocomotiveScroll from 'locomotive-scroll';
const locomotiveScroll = new LocomotiveScroll({
    lenisOptions: {
        wrapper: window,
        content: document.documentElement,
        lerp: 0.1,
        duration: 1.5,
        orientation: 'vertical',
        gestureOrientation: 'vertical',
		smooth: true,
        smoothMobile: false,
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 1,
        touchMultiplier: 1,
        normalizeWheel: true,
        smoothTouch : false,
        smartphone: {
            smooth: true,
        },
        mobile: {
            breakpoint: 768,
            smooth: false,
            getDirection: false,
        },
        tablet: {
            breakpoint: 1000,
            smooth: false,
            getDirection: false,
        }
        //easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    },
});

require('../..//node_modules/jquery-validation/dist/jquery.validate');
require('../..//node_modules/sweetalert2/dist/sweetalert2.all');
require('../..//node_modules/simplelightbox/dist/simple-lightbox.min');

window.$ = window.jQuery    = require('jquery');

//-> Lib GSAP
import { gsap }                 from "gsap";
import { PixiPlugin }           from "gsap/PixiPlugin.js";
import { MotionPathPlugin }     from "gsap/MotionPathPlugin.js";
import { ScrollTrigger }        from "gsap/ScrollTrigger";
import { ScrollToPlugin }       from "gsap/ScrollToPlugin";
gsap.registerPlugin(PixiPlugin, MotionPathPlugin, ScrollTrigger, ScrollToPlugin); 
import * as Svg          			from "./components/svg";
import * as Menu                    from "./components/Menu";
import * as mask                    from "./components/inputMask";
import * as bootstrap               from 'bootstrap'
import * as SimpleLightbox          from "./components/SimpleLightBox";
import * as FormAjax 			    from "./components/FormAjax";
import * as ModalVideo              from "./components/ModalVideo";
import * as jqValidate          	from "./components/JqValidate";

import SwiperGalleries      from './components/SwiperGallery';
import LoadPage             from "./components/AjaxLoadPage";
import windowScrollPage     from "./components/windowScrollPage";
import ModalWhats           from './components/ModalWhats';
import Swal from 'sweetalert2';
// import Swiper                       from "./components/SwiperGallery";
// import 'slick-carousel';
// import * as gallery             from "./components/slick-carrossel";
//import * as jqValidate          from "./components/JqValidate";

$(function(){
    Svg.init();
    setTimeout(() => {
        windowScrollPage.init();
    }, 500);
})

window.addEventListener('load', function(){
	render();
});

const render = () => {

    LoadPage.init();
    Menu.init();
	mask.jqMAsk();
	// Swiper.init();
	jqValidate.default();
    mask.jqMAsk();
    SimpleLightbox.init();
    ModalVideo.init();
    // controlVideos.playVideo();
    ModalWhats.init();
    FormAjax.init();
    
    SwiperGalleries.galleryAreas();
    SwiperGalleries.galleryLocation();
    SwiperGalleries.galleryAptos();
    SwiperGalleries.galleryDiferenciais();
    // SwiperGalleries.swiperNavGalPlanta();
    SwiperGalleries.init();
	
}

// integration
$(document).on('submit', '.up-integration', function(e){
    e.preventDefault();

    console.log('submiting...');

    const el        = $(this);
    const button    = el.find('button');

    button.attr('disabled', 'disabled');
    button.text('Enviando');

    // if( $(this).hasClass('form-modal-whats') ) {
    //     const url = "https://wa.me/551100000000";
    //     window.open(url, '_blank').focus();
    // }



});


// this function this respost of success of .js "up-integration"
window.callbackIntegrationOne = function(form,status, response) {

    const button = form.find('button');

    console.log('status: ' + status);

    if(status == true) {

        // gtag('event', 'send-form-one', {
        //     formSend: 'success'
        // });
        fbq('trackCustom', 'form-one', {'send-form-one': 'success'});

        console.log('send-form-one : success');

        //Geral para analitycs
        //gtag('event', 'conversao-one');

        form.prepend('<div class="text alert alert-success w-100" role="alert">Em breve um corretor entrará em contato</div>');

    } else {
        form.prepend('<div class="text alert alert-danger w-100" role="alert">Ops, ocorreu um erro...</div>');
    }

    setTimeout(() => {
        form.find('.alert').slideToggle('slow', function(){
            $(this).remove();
        });
    }, 5000);

    // if( $(this).hasClass('form-modal-whats') ) {
    //     const url = "https://wa.me/551100000000000";
    //     window.open(url, '_blank').focus();
    // }

    // envio GA
    /* gtag('event', 'send-form-one', {
        formSend: 'success'
    });
    fbq('trackCustom', 'form-one', {'send-form-one': 'success'}); */

    console.log('formSend : success');

    form[0].reset();

    // button.removeAttr('disabled');
    // button.text('Enviar');    
    button.remove();    

}